'use client';
import { usePagination } from 'react-instantsearch';
import { useSearchParams, useRouter, usePathname } from 'next/navigation';
import CustomPagination from '@/components/Pagination';

const Pagination = ({ perPage, totalHits }) => {
	const { currentRefinement, nbHits, refine } = usePagination({ itemsPerPage: perPage });
	const router = useRouter();
	const searchParams = useSearchParams();
	const pathname = usePathname(); // get current path

	const currentPage = parseInt(searchParams.get('page') || currentRefinement + 1, 10);

	const onPaginationChange = (_, page) => {
		refine(page - 1); // Algolia is 0-based

		const query = Object.fromEntries(searchParams.entries());
		if (page > 1) query.page = page;
		else delete query.page;

		// Build proper URL string
		const queryString = new URLSearchParams(query).toString();
		const url = queryString ? `${pathname}?${queryString}` : pathname;

		router.replace(url); // <-- pass URL string
		window.scrollTo({ top: 0, behavior: 'smooth' });
	};

	if (totalHits <= perPage) return null;

	return (
		<CustomPagination
			total={totalHits}
			pageSize={perPage}
			pageNumbersToShow={5}
			currentRefinement={currentPage}
			onCategoryChange={onPaginationChange}
			searchParams={searchParams}
		/>
	);
};

export default Pagination;
